<template>
<div class="product-statistics">
    
</div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    props: {
        startTime: {
            type: Number,
            default: 1735056000
        },
        endTime: {
            type: Number,
            default: () => Math.floor(new Date().getTime()/1000)
        }
    },
    methods:{
        
    },
    created(){
    },
    watch: {
        // 监听时间范围变化
        startTime: {
            handler() {
                // 这里可以添加重新获取数据的逻辑
                console.log('ProductStatistics startTime changed:', this.startTime);
            }
        },
        endTime: {
            handler() {
                // 这里可以添加重新获取数据的逻辑
                console.log('ProductStatistics endTime changed:', this.endTime);
            }
        }
    }
}
</script>

<style lang="scss">
.product-statistics{
    
}
</style>